/**
 * Resolves the current member's RBAC permissions once, as early as possible.
 *
 * Running this in a plugin (rather than only via the composable's watcher)
 * guarantees the `/api/me` lookup is *awaited during SSR*, so the resolved
 * role/pages/schedules are serialized into the payload and hydrated on the
 * client. That removes the server/client race that previously left the sidebar
 * empty (and routes intermittently failing) until a manual refresh.
 *
 * The fetch is cookie-forwarding (see `usePermissions`), so it is correctly
 * authenticated on the server. Failures fall back to the locked-down state
 * inside `load()` and never throw, so a transient `/api/me` problem can't break
 * navigation.
 */
export default defineNuxtPlugin(async () => {
  // Always resolve via the server (cookie-authenticated). We don't gate on the
  // client `useSupabaseUser()` ref, which can be null even with a valid session.
  await usePermissions().load()
})
